import { array, number, object, string } from "yup";
export const cultivoValidations = object({
  cultivo: string().required(),
  envases: array().of(number()),
});
